<template>
	<div style="height: 7rem;overflow: auto;">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" style="text-align: left;">
			<el-row type="flex">
				<el-col :span="11">
					<el-form-item label="桥梁名称" prop="bridgeName"><el-input v-model="ruleForm.bridgeName"
								  placeholder="请输入桥梁名称"></el-input></el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="归属区域" prop="ascriptionName">
						<el-select class="xq-input" v-model="ruleForm.ascriptionName" placeholder="请选择归属区域"
								   style="width: 100%;">
							<el-option label="诸暨市" value="诸暨市"></el-option>
							<!-- <el-option label="康乾街道" value="康乾街道"></el-option>
							<el-option label="舞阳街道" value="舞阳街道"></el-option>
							<el-option label="阜溪街道" value="阜溪街道"></el-option> -->
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="经度" prop="longitude">
						<el-input v-model="ruleForm.longitude" placeholder="请输入经度">
							<el-button @click="getMapClick(ruleForm)" slot="append"
									   icon="el-icon-location-outline"></el-button>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="纬度" prop="latitude">
						<el-input v-model="ruleForm.latitude" placeholder="请输入纬度"><el-button slot="append"
									   icon="el-icon-location-outline"></el-button></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="模型地址" prop="bridgeModelAddress"><el-input v-model="ruleForm.bridgeModelAddress"
								  placeholder="请输入模型地址"></el-input></el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="旋转弧度值" prop="bridgeRotationAmount">
						<el-input type="number" v-model="ruleForm.bridgeRotationAmount" placeholder="请输入旋转弧度值"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11">
					<el-form-item label="巡检单位">
						<el-select v-model="ruleForm.curingUtilUuid" @change="bridgeChange" filterable clearable
								   placeholder="请选择">
							<el-option v-for="(item, index) in bridgeData" :key="index" :label="item.departmentName"
									   :value="item.departmentUuid"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="管理单位">
						<el-select v-model="ruleForm.managementUnit" @change="bridgeChange" filterable clearable
								   placeholder="请选择">
							<el-option v-for="(item, index) in bridgeData" :key="index" :label="item.departmentName"
									   :value="item.departmentName"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="地址" prop="address">
						<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" maxlength="150" show-word-limit
								  v-model="ruleForm.address" placeholder="请输入地址"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="介绍" prop="introduce">
						<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" maxlength="1500" show-word-limit
								  v-model="ruleForm.introduce" placeholder="请输入介绍"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="告警人" prop="warnPhones">
						<el-input type="text" v-model="ruleForm.warnPhones" placeholder="请输入告警人"></el-input>
						<div>多个电话号码用","分隔</div>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="" prop="isIot">
						<el-checkbox v-model="ruleForm.isIot" :true-label="1" :false-label="0">有监测设备</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<!-- <div class="xq-fixed">
			<div class="xq-btn">
				<el-button type="primary" @click="add_sure('ruleForm')">确 定</el-button>
				<el-button @click="addVisible = false">取 消</el-button>
			</div>
		</div> -->
		<!--  地图选点对话框-->
		<el-dialog :visible.sync="mapDialog" :modal="false" append-to-body title="地图选点" style="width: 100%;">
			<getMap @getLngLat="getLngLat" @close="mapDialog = false" ref="getMap" :Mapcenter="Mapcenter"></getMap>
		</el-dialog>
	</div>
</template>

<script>
import getMap from '../../../components/getMap/index.vue'
export default {
	name: 'xiangqing',
	components: {
		getMap
	},
	props: [],
	data() {
		return {
			ruleForm: {
				bridgeName: '',
				bridgeId: null,
				bridgeUuid: '',
				ascriptionName: '',
				longitude: '',
				latitude: '',
				// inspectionCycle: 1,
				// inspectionCycleStart: '',
				bridgeModelAddress: '',
				bridgeRotationAmount: '',
				address: '',
				introduce: '',
				curingUtil: '',
				curingUtilUuid: '',
				managementUnit:"",
				warnPhones: '',
				isIot:0,
			},
			// 地图选点显示框
			mapDialog: false,
			MapCentet: [],
			starOrEnd: 'star',
			Mapcenter: [], //传入组件的经纬度 Mapcenter:[lng,lat]
			lng: '',
			lat: '',
			rules: {
				bridgeName: [
					{
						required: true,
						message: '请输入桥梁名称',
						trigger: 'blur'
					}
				],
				longitude: [
					{
						required: true,
						message: '请输入经度',
						trigger: 'blur'
					}
				],
				latitude: [
					{
						required: true,
						message: '请输入纬度',
						trigger: 'blur'
					}
				]
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now()
				}
			},
			bridgeData: []
		}
	},
	mounted() {
		this.getDepartment()
	},
	computed:{
	},
	methods: {
		// 获取-部门名称列表
		async getDepartment() {
			let data = {
				pageSize: 99999,
				pageNum: 1
			}
			const res = await this.$api.sendPost('/enterpriseDepartment/getAllEnterpriseTWO', data)
			console.log('部门名称', res)
			if (res.errcode == 0) {
				if (res.data && res.data.length > 0) {
					this.bridgeData = res.data
				} else {
					this.bridgeData = []
				}
			}
			if (this.ruleForm.curingUtilUuid != '') {
				var add = this.bridgeData.find(item => {
					return item.departmentUuid == this.ruleForm.curingUtilUuid
				})
				if (add) {
					this.ruleForm.curingUtil = add.departmentName
				} else {
					this.ruleForm.curingUtil = ''
				}
			}
		},
		async bridgeChange(e) {
			var add = this.bridgeData.find(item => {
				return item.departmentUuid == this.ruleForm.curingUtilUuid
			})
			this.ruleForm.curingUtil = add.departmentName
		},
		xiangQingBC() {
			// console.log(this.ruleForm.inspectionCycle);
			// if(this.ruleForm.inspectionCycle!=null){
			// 	this.ruleForm.inspectionCycle=Number(this.ruleForm.inspectionCycle)
			// }
			this.$refs.ruleForm.validate(async valid => {
				if (valid) {
					let data = {
						...this.ruleForm,
						createByName: this.$store.state.user.accountName,
						createByUuid: this.$store.state.user.accountUuid
					}
					if(this.$route.path.indexOf("home/qiaoliangliebiao") > -1){
						data.facilityTypeName = "桥梁"
					}else if(this.$route.path.indexOf("home/suidaoliebiao") > -1){
						data.facilityTypeName = "隧道"
					}
					let url = ''
					if (global.isUpdate) {
						// 修改
						url = '/biBridge/update'
					} else {
						// 新增
						url = '/biBridge/save'
					}
					console.log('上传数据》》》', data)
					const res = await this.$api.sendPost(url, data)
					console.log(res)
					if (res.errcode == 0) {
						if (global.isUpdate) {
							global.bridgeUuid = this.ruleForm.bridgeUuid
						} else {
							global.bridgeUuid = res.data
						}
						this.$message.success(res.errmsg)
						// global.index = '1';
						this.$emit('updateIndex', '2')
					} else {
						this.$message.error(res.errmsg)
					}
				} else {
					return false
				}
			})
		},
		resetForm() {
			this.$refs.ruleForm.resetFields()
		},
		getMapClick(data) {
			// console.log(num, data)
			this.mapDialog = true
			if (data.longitude && data.latitude) {
				// console.log(data.longitudeStart, data.latitudeStart);
				// lon_lat.push(data.longitudeStart, data.latitudeStart)
				this.Mapcenter = [Number(this.ruleForm.longitude), Number(this.ruleForm.latitude)]
			}
			console.log(this.Mapcenter)
		},
		getLngLat(lng, lat, a) {
			this.ruleForm.longitude = lng
			this.ruleForm.latitude = lat
			this.ruleForm.position = a
			this.$set(this.ruleForm, 'address', a)
			// console.log(this.ruleForm.position);
			this.mapDialog = false
		}
	}
}
</script>

<style lang="scss" scoped>
.xq-input {
	width: 400px;
}

.xq-fixed {

	// position: absolute;
	// bottom: 0;
	.xq-btn {
		display: flex;
		justify-content: flex-end;
	}
}
</style>
